// NEW: UI_REVAMP
import {
	Box,
	Drawer,
	DrawerContent,
	DrawerHeader,
	DrawerOverlay,
	Flex,
	Text,
} from '@chakra-ui/react';
import useIsMobileView from '../../../hooks/useIsMobileView';

export const FilterPanelHeader = ({ onClose }) => {
	const isMobileView = useIsMobileView();
	return (
		<Flex alignItems='center' justifyContent='space-between' marginBottom='12px'>
			<Text fontSize={isMobileView ? '14px' : '16px'} fontWeight='500' color='#111111'>
				Filter
			</Text>
			<Box
				as='button'
				type='button'
				width='24px'
				height='24px'
				fontSize='24px'
				lineHeight='20px'
				color='#111111'
				onClick={onClose}
			>
				×
			</Box>
		</Flex>
	);
};

export const DesktopFilterContainer = ({ isOpen, isCalendarView, onClose, children }) => {
	if (!isOpen) return null;

	return (
		<Box
			position='absolute'
			top='52px'
			right='0'
			zIndex='20'
			width='100%'
			maxWidth='450px'
			minHeight={isCalendarView ? '560px' : '420px'}
			padding='16px'
			display='flex'
			flexDirection='column'
			backgroundColor='#F0EEFF'
			borderRadius='16px'
			boxShadow='0 4px 12px rgba(100, 72, 180, 0.2)'
		>
			<FilterPanelHeader onClose={onClose} />
			{children}
		</Box>
	);
};

export const MobileFilterContainer = ({ isOpen, onClose, children }) => {
	return (
		<Drawer isOpen={isOpen} placement='bottom' onClose={onClose}>
			<DrawerOverlay background='rgba(17, 17, 17, 0.45)' />
			<DrawerContent
				background='transparent'
				boxShadow='none'
				maxWidth='375px'
				marginX='auto'
				borderRadius='24px 24px 0 0'
				overflow='hidden'
			>
				<Box
					position='relative'
					bg='rgba(238, 233, 254, 0.5)'
					borderTopRadius='24px'
					boxShadow='0 -8px 20px rgba(100, 72, 180, 0.18)'
					backdropFilter='blur(10px)'
					paddingTop='12px'
					paddingX='8px'
					paddingBottom='calc(12px + env(safe-area-inset-bottom))'
				>
					<Box
						position='absolute'
						inset={0}
						border='2px solid rgba(163, 151, 242, 1)'
						borderTopRadius='24px'
						sx={{
							maskImage: `linear-gradient(to bottom,rgba(255,255,255,1) 0%,rgba(255,255,255,1)  25%,transparent 75%,transparent 100%)`,
							maskSize: '100% 100%',
							maskRepeat: 'no-repeat',
							WebkitMaskImage: `linear-gradient(to bottom,rgba(255,255,255,1)  0%,rgba(255,255,255,1)  25%,transparent 75%,transparent 100%)`,
							WebkitMaskSize: '100% 100%',
							WebkitMaskRepeat: 'no-repeat',
						}}
						pointerEvents='none'
					/>
					<DrawerHeader padding='0 0 12px 0'>
						<FilterPanelHeader onClose={onClose} />
					</DrawerHeader>
					{children}
				</Box>
			</DrawerContent>
		</Drawer>
	);
};
